/*
 * Oblivion buy box — behaviour for snippets/oblivion-buybox.liquid   v1.0.0
 *
 *  - quantity stepper, Add to cart (theme OB.Cart when present, else /cart/add.js)
 *  - Buy now: GoKwik onBuyNowClick(button, false, [{id, quantity}]) when the
 *    GoKwik script is on the page, otherwise add to cart and go to /checkout
 *  - wishlist heart, sharing the theme localStorage key (ob_wish)
 *  - trust strip slider, dispatch countdown and order timeline, both in IST
 *  - keeps every instance of the same product in step: OBBuy.setVariant(id, variant)
 *    from the Oblivion section, and the Horizon variant:update event
 *  - "Delivered" dates follow the pincode estimate from assets/oblivion-edd.js
 *    (ob:edd event), so the two widgets never quote different days
 *
 * Never computes a price: every amount comes from Liquid or from the variant
 * JSON the snippet prints. ES5, no dependencies, safe to include twice.
 */
(function () {
  'use strict';
  if (window.OBBuy && window.OBBuy.version) { window.OBBuy.init(); return; }

  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var IST_OFFSET_MIN = 330;
  var SKIP = '#quick-add-modal-content, quick-add-dialog, template';
  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var products = {};
  var edd = null;
  var ticker = null;
  var cartPending = {};

  /* ---------------- helpers ---------------- */
  function qsa(sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }
  function inert(el) { return !!(el && el.closest && el.closest(SKIP)); }
  function roots(pid) {
    return qsa('[data-obk]').filter(function (r) {
      return !inert(r) && (pid == null || r.getAttribute('data-obk-product') === String(pid));
    });
  }
  function rootUrl() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function attrNum(el, name, dflt) { var n = parseInt(el.getAttribute(name), 10); return isNaN(n) ? dflt : n; }
  function setText(scope, sel, text) { qsa(sel, scope).forEach(function (e) { e.textContent = text; }); }
  function setShown(scope, sel, on) { qsa(sel, scope).forEach(function (e) { e.hidden = !on; }); }

  /* Shopify money_format renderer — cents in, formatted string out */
  function money(cents, format) {
    var parts = (Math.round(cents) / 100).toFixed(2).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return String(format || '₹{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      return name.indexOf('no_decimals') > -1 ? whole : whole + '.' + parts[1];
    });
  }

  /* ---------------- variant state, one entry per product ---------------- */
  function byId(list, id) {
    id = parseInt(id, 10);
    for (var i = 0; i < list.length; i++) { if (list[i].id === id) return list[i]; }
    return null;
  }
  function product(pid) {
    pid = String(pid);
    if (products[pid]) return products[pid];
    var entry = { variants: [], variant: null };
    var list = roots(pid);
    for (var i = 0; i < list.length; i++) {
      var json = list[i].querySelector('script[data-obk-variants]');
      if (!json) continue;
      try { entry.variants = JSON.parse(json.textContent) || []; } catch (e) { entry.variants = []; }
      entry.variant = byId(entry.variants, list[i].getAttribute('data-obk-variant')) || entry.variants[0] || null;
      break;
    }
    products[pid] = entry;
    return entry;
  }

  function paint(pid) {
    var v = product(pid).variant;
    if (!v) return;
    var mrp = v.compare_at_price || 0;
    var onSale = mrp > v.price;
    var off = onSale ? Math.floor((mrp - v.price) * 100 / mrp) : 0;
    roots(pid).forEach(function (r) {
      var format = r.getAttribute('data-obk-money');
      r.setAttribute('data-obk-variant', v.id);
      setText(r, '[data-obk-now]', money(v.price, format));
      setText(r, '[data-obk-mrp]', money(mrp, format));
      setShown(r, '[data-obk-mrpwrap]', onSale);
      setText(r, '[data-obk-offn]', String(off));
      setShown(r, '[data-obk-off]', off >= 1);
      setText(r, '[data-obk-save]', money(Math.max(0, mrp - v.price), format));
      setShown(r, '[data-obk-savewrap]', onSale);
      qsa('[data-obk-id]', r).forEach(function (input) { input.value = v.id; });
      qsa('[data-obk-atc]', r).forEach(function (b) {
        b.disabled = !v.available || !!cartPending[pid];
        setText(b, '[data-obk-atc-label]', cartPending[pid] ? 'Adding...' : (v.available ? 'Add to cart' : 'Out of stock'));
      });
      qsa('[data-obk-buynow]', r).forEach(function (b) { b.disabled = !v.available; });
      setShown(r, '[data-obk-disp]', !!v.available);
      qsa('[data-obk-qty]', r).forEach(function (q) {
        if (v.max > 0) q.setAttribute('max', v.max); else q.removeAttribute('max');
        clampQty(q);
      });
    });
  }

  function setVariant(pid, variant) {
    if (pid == null || !variant || variant.id == null) return;
    var entry = product(pid);
    var known = byId(entry.variants, variant.id);
    if (!known) {
      known = {
        id: parseInt(variant.id, 10),
        price: parseInt(variant.price, 10) || 0,
        compare_at_price: parseInt(variant.compare_at_price, 10) || 0,
        available: variant.available !== false,
        max: 0
      };
      entry.variants.push(known);
    } else if (typeof variant.available === 'boolean') {
      known.available = variant.available;
    }
    entry.variant = known;
    paint(pid);
  }

  /* ---------------- quantity ---------------- */
  function clampQty(input) {
    var n = parseInt(input.value, 10);
    if (!(n >= 1)) n = 1;
    var max = parseInt(input.getAttribute('max'), 10);
    if (max > 0 && n > max) n = max;
    if (n > 999) n = 999;
    if (String(n) !== input.value) input.value = n;
    return n;
  }
  function qtyOf(pid) {
    var inputs = roots(pid).map(function (r) { return r.querySelector('[data-obk-qty]'); }).filter(Boolean);
    return inputs.length ? clampQty(inputs[0]) : 1;
  }

  /* ---------------- cart ---------------- */
  function toast(message) {
    if (window.OB && typeof OB.toast === 'function') { OB.toast(message); return; }
    var el = document.createElement('div');
    el.className = 'obk-toast';
    el.setAttribute('role', 'status');
    el.textContent = message;
    document.body.appendChild(el);
    setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 2600);
  }
  function busy(btn, on) {
    if (!btn) return;
    if (on) btn.classList.add('is-busy'); else btn.classList.remove('is-busy');
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
  }
  function track(event, variant, qty) {
    try {
      (window.dataLayer = window.dataLayer || []).push({
        event: event,
        obk_variant: variant && variant.id,
        obk_quantity: qty,
        obk_value: variant ? (variant.price * qty) / 100 : 0
      });
    } catch (e) { /* analytics is best-effort */ }
  }
  function cartAdd(id, qty) {
    if (window.OB && OB.Cart && typeof OB.Cart.add === 'function') return OB.Cart.add(id, qty);
    return fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
        try { document.dispatchEvent(new CustomEvent('ob:cart:added', { detail: data })); } catch (e) { /* old WebView */ }
        return data;
      });
    });
  }
  function addToCart(pid, btn) {
    if (cartPending[pid]) return cartPending[pid];
    var v = product(pid).variant;
    if (!v || !v.available) return Promise.reject(new Error('This item is out of stock'));
    var qty = qtyOf(pid);
    cartStatus(pid, '', false);
    cartButtons(pid, btn, true);
    var request = Promise.resolve().then(function () { return cartAdd(v.id, qty); });
    cartPending[pid] = request.then(function (res) {
      delete cartPending[pid];
      cartButtons(pid, btn, false, true);
      cartStatus(pid, qty > 1 ? qty + ' items added to cart.' : 'Added to cart.', false);
      toast(qty > 1 ? qty + ' items added to cart' : 'Added to cart');
      track('ob_buybox_add_to_cart', v, qty);
      return res;
    }, function (err) {
      delete cartPending[pid];
      cartButtons(pid, btn, false);
      var message = (err && err.message) || 'Could not add to cart. Please try again.';
      cartStatus(pid, message, true);
      toast(message);
      throw err;
    });
    return cartPending[pid];
  }
  function cartButtons(pid, clicked, pending, added) {
    var buttons = [];
    roots(pid).forEach(function (r) { buttons = buttons.concat(qsa('[data-obk-atc]', r)); });
    qsa('[data-obk-sticky-atc]').forEach(function (b) {
      if (b.getAttribute('data-obk-product') === String(pid)) buttons.push(b);
    });
    if (clicked && buttons.indexOf(clicked) < 0) buttons.push(clicked);
    var v = product(pid).variant;
    buttons.forEach(function (b) {
      busy(b, pending);
      b.disabled = pending || !v || !v.available;
      var label = b.querySelector('[data-obk-atc-label]') || b;
      label.textContent = pending ? 'Adding...' : (!v || !v.available ? 'Out of stock' : (added ? 'Added to cart' : 'Add to cart'));
    });
  }
  function cartStatus(pid, message, error) {
    roots(pid).forEach(function (r) {
      var form = r.querySelector('.obk-buy');
      if (!form) return;
      var status = form.querySelector('[data-obk-cart-status]');
      if (!status) {
        status = document.createElement('p');
        status.setAttribute('data-obk-cart-status', '');
        status.setAttribute('role', 'status');
        status.setAttribute('aria-live', 'polite');
        form.appendChild(status);
      }
      status.className = 'obk-cart-status' + (error ? ' is-error' : '');
      status.hidden = !message;
      status.textContent = message;
      if (message && !error) {
        var link = document.createElement('a');
        link.href = rootUrl() + 'cart';
        link.textContent = 'View cart';
        status.appendChild(link);
      }
    });
  }
  function buyNow(pid, btn) {
    var v = product(pid).variant;
    if (!v || !v.available) return;
    var qty = qtyOf(pid);
    track('ob_buybox_buy_now', v, qty);
    if (typeof window.onBuyNowClick === 'function') {
      /* GoKwik owns checkout: hand it the variant and quantity directly */
      try { window.onBuyNowClick(btn, false, [{ id: v.id, quantity: qty }]); return; } catch (e) { /* fall back below */ }
    }
    busy(btn, true);
    cartAdd(v.id, qty).then(function () {
      location.href = rootUrl() + 'checkout';
    }, function (err) {
      busy(btn, false);
      toast((err && err.message) || 'Could not add to cart');
    });
  }

  /* ---------------- wishlist (this browser only) ---------------- */
  function wishAll() {
    try { return JSON.parse(localStorage.getItem('ob_wish')) || {}; } catch (e) { return {}; }
  }
  function wishHas(handle) {
    if (window.OB && OB.Wish) return OB.Wish.has(handle);
    return !!wishAll()[handle];
  }
  function wishToggle(handle) {
    if (window.OB && OB.Wish) return OB.Wish.toggle(handle);
    var all = wishAll();
    if (all[handle]) delete all[handle]; else all[handle] = 1;
    try { localStorage.setItem('ob_wish', JSON.stringify(all)); } catch (e) { /* private mode */ }
    return !!all[handle];
  }
  function paintWish() {
    qsa('[data-obk-wish]').forEach(function (b) {
      var r = b.closest('[data-obk]');
      if (!r) return;
      var on = wishHas(r.getAttribute('data-obk-handle'));
      if (on) b.classList.add('is-on'); else b.classList.remove('is-on');
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Save to wishlist');
    });
    var gallery = document.getElementById('obWishBtn');
    var first = roots()[0];
    if (gallery && first) {
      if (wishHas(first.getAttribute('data-obk-handle'))) gallery.classList.add('on');
      else gallery.classList.remove('on');
    }
  }

  /* ---------------- dispatch countdown and timeline ---------------- */
  function istNow() {
    var d = new Date();
    return new Date(d.getTime() + (d.getTimezoneOffset() + IST_OFFSET_MIN) * 60000);
  }
  function plusDays(from, days) {
    var d = new Date(from.getFullYear(), from.getMonth(), from.getDate(), 12, 0, 0, 0);
    d.setDate(d.getDate() + days);
    return d;
  }
  function dayLabel(d) { return MONTHS[d.getMonth()] + ' ' + d.getDate(); }
  function dayRange(a, b) {
    var x = dayLabel(a), y = dayLabel(b);
    return x === y ? x : x + ' - ' + y;
  }
  function pad2(n) { return (n < 10 ? '0' : '') + n; }

  function tick() {
    var cards = qsa('[data-obk-disp]:not([data-obk-policy])').filter(function (c) { return !inert(c); });
    if (!cards.length) return;
    var now = istNow();
    cards.forEach(function (card) {
      var hour = attrNum(card, 'data-cutoff', 14);
      if (hour < 0 || hour > 23) hour = 14;
      var cutAt = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hour, 0, 0, 0);
      var passed = now.getTime() >= cutAt.getTime();
      if (passed) cutAt = new Date(cutAt.getFullYear(), cutAt.getMonth(), cutAt.getDate() + 1, hour, 0, 0, 0);
      var left = Math.max(0, Math.floor((cutAt.getTime() - now.getTime()) / 1000));

      setText(card, '[data-obk-h]', pad2(Math.floor(left / 3600)));
      setText(card, '[data-obk-m]', pad2(Math.floor((left % 3600) / 60)));
      setText(card, '[data-obk-s]', pad2(left % 60));
      setText(card, '[data-obk-for]', card.getAttribute(passed ? 'data-after' : 'data-for') || '');
      qsa('[data-obk-bar]', card).forEach(function (bar) {
        bar.style.width = Math.min(100, Math.max(0, 100 - left / 864)).toFixed(2) + '%';
      });

      var shift = passed ? 1 : 0;
      var readyMin = Math.max(0, attrNum(card, 'data-ready-min', 1));
      var readyMax = Math.max(readyMin, attrNum(card, 'data-ready-max', 2));
      var lo, hi;
      if (edd) {
        lo = edd.lo;
        hi = edd.hi;
        /* the parcel cannot be ready after it is delivered */
        readyMax = Math.min(readyMax, Math.max(0, hi - shift - 1));
        readyMin = Math.min(readyMin, readyMax);
      } else {
        lo = attrNum(card, 'data-deliver-min', 4) + shift;
        hi = attrNum(card, 'data-deliver-max', 6) + shift;
      }
      var earliest = shift + readyMax + 1;
      if (lo < earliest) lo = earliest;
      if (hi < lo) hi = lo;

      setText(card, '[data-obk-d1]', dayLabel(now));
      setText(card, '[data-obk-d2]', dayRange(plusDays(now, shift + readyMin), plusDays(now, shift + readyMax)));
      setText(card, '[data-obk-d3]', dayRange(plusDays(now, lo), plusDays(now, hi)));
    });
  }

  function takeEdd(lo, hi) {
    lo = parseInt(lo, 10);
    hi = parseInt(hi, 10);
    if (!(hi > 0)) return;
    if (!(lo > 0) || lo > hi) lo = hi;
    edd = { lo: lo, hi: hi };
    tick();
  }
  function eddFromDataLayer() {
    var dl = window.dataLayer;
    if (!dl || !dl.length) return;
    for (var i = dl.length - 1; i >= 0; i--) {
      var row = dl[i];
      if (row && row.event === 'ob_edd_result') { takeEdd(row.edd_days_lo, row.edd_days); return; }
    }
  }

  /* ---------------- trust strip ---------------- */
  function slider(box) {
    if (box.getAttribute('data-obk-ready')) return;
    var track = box.querySelector('[data-obk-trust-track]');
    var pages = track ? qsa('.obk-trust__page', track) : [];
    var dots = qsa('[data-obk-dot]', box);
    if (pages.length < 2) return;
    box.setAttribute('data-obk-ready', '1');
    var at = 0, timer = null;

    function go(n) {
      at = (n + pages.length) % pages.length;
      track.style.transform = 'translateX(' + (-100 * at) + '%)';
      pages.forEach(function (p, k) { p.setAttribute('aria-hidden', k === at ? 'false' : 'true'); });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === at ? 'true' : 'false'); });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (reduceMotion) return;
      timer = setInterval(function () {
        if (!document.body.contains(box)) { stop(); return; }
        if (!document.hidden) go(at + 1);
      }, 3800);
    }

    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); start(); }); });
    box.addEventListener('mouseenter', stop);
    box.addEventListener('mouseleave', start);
    box.addEventListener('focusin', stop);
    box.addEventListener('focusout', start);
    var startX = null;
    box.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; stop(); }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (startX !== null) {
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 30) go(at + (dx < 0 ? 1 : -1));
      }
      startX = null;
      start();
    }, { passive: true });

    go(0);
    start();
  }

  /* the sticky buy bar of the Oblivion section hides while the inline row shows */
  function watchBuyBar() {
    var bar = document.getElementById('obBuybar');
    if (!bar || bar.getAttribute('data-obk-watch') || !('IntersectionObserver' in window)) return;
    var inline = qsa('.obk-buy').filter(function (el) { return !inert(el); })[0];
    if (!inline) return;
    bar.setAttribute('data-obk-watch', '1');
    new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) bar.classList.add('obk-away');
      else bar.classList.remove('obk-away');
    }, { threshold: 0 }).observe(inline);
  }

  /* ---------------- wiring ---------------- */
  document.addEventListener('click', function (e) {
    var hit = e.target && e.target.closest
      ? e.target.closest('[data-obk-minus],[data-obk-plus],[data-obk-atc],[data-obk-buynow],[data-obk-wish]')
      : null;
    if (!hit) return;
    var r = hit.closest('[data-obk]');
    if (!r || inert(r)) return;
    var pid = r.getAttribute('data-obk-product');

    if (hit.hasAttribute('data-obk-minus') || hit.hasAttribute('data-obk-plus')) {
      var input = r.querySelector('[data-obk-qty]');
      if (input) {
        input.value = (parseInt(input.value, 10) || 1) + (hit.hasAttribute('data-obk-plus') ? 1 : -1);
        clampQty(input);
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    } else if (hit.hasAttribute('data-obk-atc')) {
      e.preventDefault();
      addToCart(pid, hit).catch(function () { /* the toast already told the shopper */ });
    } else if (hit.hasAttribute('data-obk-buynow')) {
      e.preventDefault();
      buyNow(pid, hit);
    } else {
      var on = wishToggle(r.getAttribute('data-obk-handle'));
      paintWish();
      toast(on ? 'Saved to wishlist' : 'Removed from wishlist');
    }
  });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-obk-qty')) clampQty(e.target);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target && e.target.hasAttribute && e.target.hasAttribute('data-obk-qty')) {
      e.preventDefault();
      clampQty(e.target);
    }
  });
  document.addEventListener('ob:edd', function (e) {
    var d = e.detail || {};
    takeEdd(d.lo, d.hi);
  });
  document.addEventListener('ob:edd:error', function () { edd = null; tick(); });
  /* Horizon variant picker */
  document.addEventListener('variant:update', function (e) {
    var detail = e.detail || {};
    var variant = detail.resource || detail.variant;
    if (!variant || variant.id == null) return;
    var pid = detail.data && detail.data.productId;
    if (pid == null) {
      var owner = roots().filter(function (r) {
        return byId(product(r.getAttribute('data-obk-product')).variants, variant.id);
      })[0];
      pid = owner ? owner.getAttribute('data-obk-product') : null;
    }
    if (pid != null && roots(pid).length) setVariant(pid, variant);
  });
  document.addEventListener('shopify:section:load', function () { init(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) { paintWish(); tick(); } });

  function init() {
    products = {};
    qsa('[data-obk-trust]').forEach(function (box) { if (!inert(box)) slider(box); });
    paintWish();
    eddFromDataLayer();
    tick();
    if (!ticker) ticker = setInterval(tick, 1000);
    watchBuyBar();
  }

  window.OBBuy = {
    version: '1.0.0',
    init: init,
    setVariant: setVariant,
    qty: qtyOf,
    addToCart: addToCart,
    buyNow: buyNow,
    paintWish: paintWish
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
